export default "__VITE_ASSET__B4W2Zeve__"